import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  Divider,
  IconButton,
} from "@mui/material";
import { EmailOutlined, PhoneOutlined } from "@mui/icons-material";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <Box
      sx={{
        py: 8,
        background: "linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)",
        position: "relative",
        color: "#fff",
      }}
    >
      <Container>
        <Grid container spacing={6}>
          {/* Logo Section */}
          <Grid item xs={12} md={4}>
            <Box sx={{ mb: 1 }}>
              <Box
                component="img"
                src="https://res.cloudinary.com/duaz5kg1m/image/upload/v1739294825/logo1_6_phzl1b.png"
                alt="VastuPlan Logo"
                sx={{
                  maxWidth: "220px",
                  height: "auto",
                  mb: 3,
                  filter: "brightness(1.2)",
                }}
              />
              <Typography
                variant="body1"
                sx={{
                  color: "#e0e0e0",
                  fontStyle: "italic",
                  letterSpacing: "0.5px",
                  fontSize: "1rem",
                  fontWeight: 300,
                }}
              >
                Where Ancient Wisdom Meets Modern Living
              </Typography>
            </Box>
          </Grid>

          {/* Quick Links (Updated with NavBar-like behavior) */}
          <Grid item xs={12} md={4}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                color: "#fff",
                fontWeight: 700,
                mb: 3,
                position: "relative",
                letterSpacing: "0.05em",
                textTransform: "uppercase",
                fontSize: "1rem",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: -8,
                  left: 0,
                  width: "30px",
                  height: "3px",
                  background: "#ff4444",
                  borderRadius: "2px",
                },
              }}
            >
              Quick Links
            </Typography>
            <Grid container spacing={1.5}>
              {[
                { label: "Home", path: "/landing" },
                { label: "About", path: "/about-us" },
                { label: "Blog", path: "/blog" },
                { label: "Contact", path: "/contact" },
              ].map((link) => (
                <Grid item xs={6} key={link.label}>
                  <Button
                    component={Link}
                    to={link.path}
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    sx={{
                      textTransform: "none",
                      color: "#e0e0e0",
                      position: "relative",
                      pl: 2.5,
                      fontSize: "0.95rem",
                      fontWeight: 400,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        backgroundColor: "transparent",
                        color: "#ff4444",
                        transform: "translateX(5px)",
                      },
                    }}
                  >
                    {link.label}
                  </Button>
                </Grid>
              ))}
            </Grid>
          </Grid>

          {/* Contact Section */}
          <Grid item xs={12} md={4}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                color: "#fff",
                fontWeight: 700,
                mb: 3,
                position: "relative",
                letterSpacing: "0.05em",
                textTransform: "uppercase",
                fontSize: "1rem",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: -8,
                  left: 0,
                  width: "30px",
                  height: "3px",
                  background: "#ff4444",
                  borderRadius: "2px",
                },
              }}
            >
              Contact Us
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2.5 }}>
                <Box
                  sx={{
                    p: 1.2,
                    borderRadius: "50%",
                    backgroundColor: "rgba(255, 68, 68, 0.1)",
                    border: "2px solid rgba(255, 68, 68, 0.3)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "rgba(255, 68, 68, 0.2)",
                      transform: "scale(1.1)",
                    },
                  }}
                >
                  <EmailOutlined sx={{ fontSize: 20, color: "#ff4444" }} />
                </Box>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#e0e0e0",
                    fontSize: "0.95rem",
                    fontWeight: 400,
                    letterSpacing: "0.02em",
                    "&:hover": {
                      color: "#ff4444",
                    },
                    transition: "color 0.3s ease",
                  }}
                >
                  vastuplan@gmail.com
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2.5 }}>
                <Box
                  sx={{
                    p: 1.2,
                    borderRadius: "50%",
                    backgroundColor: "rgba(255, 68, 68, 0.1)",
                    border: "2px solid rgba(255, 68, 68, 0.3)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "rgba(255, 68, 68, 0.2)",
                      transform: "scale(1.1)",
                    },
                  }}
                >
                  <PhoneOutlined sx={{ fontSize: 20, color: "#ff4444" }} />
                </Box>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#e0e0e0",
                    fontSize: "0.95rem",
                    fontWeight: 400,
                    letterSpacing: "0.02em",
                    "&:hover": {
                      color: "#ff4444",
                    },
                    transition: "color 0.3s ease",
                  }}
                >
                  +977 9851144390
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider
          sx={{
            my: 6,
            borderColor: "rgba(255, 255, 255, 0.1)",
          }}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "rgba(255,255,255,0.8)",
              fontSize: "0.9rem",
              letterSpacing: "0.02em",
            }}
          >
            © 2025 VastuPlan. All rights reserved.
          </Typography>

          <Box sx={{ display: "flex", gap: 4 }}>
            {["Facebook", "Twitter", "Instagram", "LinkedIn"].map((social) => (
              <IconButton
                key={social}
                size="small"
                sx={{
                  color: "rgba(255,255,255,0.8)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    color: "#ffffff",
                    transform: "translateY(-3px) scale(1.1)",
                    boxShadow: "0 5px 15px rgba(255,255,255,0.1)",
                  },
                }}
              >
                <Box sx={{ width: 22, height: 22 }} />
              </IconButton>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
